import { render, staticRenderFns } from "./CompetitionsMain.vue?vue&type=template&id=3c900ae0&scoped=true"
import script from "./CompetitionsMain.vue?vue&type=script&lang=js"
export * from "./CompetitionsMain.vue?vue&type=script&lang=js"
import style0 from "./CompetitionsMain.vue?vue&type=style&index=0&id=3c900ae0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c900ae0",
  null
  
)

export default component.exports